export const CTA_TEXT = {
  SKIP: 'Skip',
  CONTINUE: 'Continue',
}

export const SIGNUP_MOTIVATIONS_TEXT = {
  title: 'What would you like to get out of Gousto?',
  description:
    'Choose up to 3 goals that matter most to you and we’ll tailor your menu to match. Don’t worry, you can still order from the full menu.',
}
